import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountFilter'
})
export class AccountFilterPipe implements PipeTransform {

  transform(arr: any, code: any): any {
    if ( code == null) {
      return arr.filter((arr: any) =>{
        return arr.category_id == null
      })
    } else{
      return arr.filter((arr: any) =>{
        return arr.category_id == code
      })
    }
  }

}
